let baseUrl = getParameterByName("_wshost");

if (!baseUrl) {
    baseUrl = __WSHOST
};

let SocketServerHost = baseUrl + "/h5Clover/pvp.ws";

let ErrcodeMap = {
  "NoOwner" : 761301,
  "PvpNotOpen" : 761302,
  "RoomFulled" : 761303,
  "GameOvered" : 761304,
  "FriendPvpNoBeHelpTimes" : 761306,
  "FriendPvpNoTicket" : 761309,
  "FriendPvpEnemyOffline" : 761314,
  "FriendPvpNoHelpTimes": 761308,
  "FriendPvpRoomFull": 761300,
  "PiggyBankNoExist": 761960,//存钱罐不存在
  "PiggyBankPayError": 761961,//存钱罐支付错误
  "PiggyBankNoBuyMin": 761962,//存钱罐没达到购买最低标准
  "PiggyBankOverdue": 761963,//存钱罐过期
  "PiggyBankNoSupport": 761964//存钱罐不被该平台支持
};
export { SocketServerHost, ErrcodeMap };